import type { FC } from "react";

import { Button, Text } from "@alpacahq/ui/old";

type TransferFormButtonsProps = {
  isSubmitEnabled: boolean;
  isConfirmDisabled: boolean;
  setIsSubmitChecked: (checked: boolean) => void;
  isSubmitChecked: boolean;
  amount: string;
  direction: "deposit" | "withdrawal";
};

export const TransferFormButtons: FC<TransferFormButtonsProps> = ({
  direction,
  isSubmitEnabled,
  isConfirmDisabled,
  setIsSubmitChecked,
  isSubmitChecked,
  amount,
}) => {
  return (
    <div className="py-4">
      {isSubmitChecked ? (
        <div>
          <Text className="pb-2 text-center font-semibold text-lg">
            Initiate {direction} of ${amount}?
          </Text>
          <div className="flex gap-4">
            <Button
              variant="red"
              className="w-full"
              onClick={() => setIsSubmitChecked(false)}
              type="button"
            >
              Cancel
            </Button>
            <Button
              disabled={!isSubmitEnabled}
              className="w-full"
              type="submit"
            >
              Yes
            </Button>
          </div>
        </div>
      ) : (
        <Button
          onClick={() => setIsSubmitChecked(true)}
          disabled={isConfirmDisabled}
          type="button"
          className="w-full"
        >
          Confirm
        </Button>
      )}
    </div>
  );
};
